<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'wfControle'" [isTitleHidden]="true"></custom-frame>
